const development_tenant = {
    notification: "You're in development mode",
};
export default Object.freeze(development_tenant);
